<template>
    <div class="col-12 opening-postParams">
        <div class="header">
            <h5> Questions </h5>
        </div>

        <questions-management
            :form-id="boardId"
            :questions="postParams"
            is-board
            class="mt-3"
        />
    </div>
</template>

<script>
import QuestionsManagement from '@/components/forms/QuestionsManagement';

export default {
    components: {
        QuestionsManagement
    },

    props: {
        value: {
            type: Array,
            required: true
        },
        boardId: {
            type: String,
            required: true
        }
    },

    data() {
        return {
            postParams: [...this.value]
        };
    },

    watch: {
        postParams: {
            handler(value) {
                this.$emit('input', value);
            },
            deep: true
        }
    },

    methods: {
        addPostParam() {
            this.postParams = [...this.postParams, {}];
        },

        deletePostParam(index) {
            this.postParams.splice(index, 1);
        },

        getError(key, index) {
            return this.$getValidationErrorMessageHandler.handle(
                this.validation,
                this.serverErrors,
                key,
                index
            );
        }
    }
};
</script>
